import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  AfterViewInit
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

import { FormInputComponent } from '../form-input/form-input.component';

import { WaiDateAdapter, WAI_DATE_FORMATS } from './form-date-picker.service';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-form-date-picker',
    templateUrl: './form-date-picker.component.html',
    styleUrls: ['./../form-controls.scss'],
    providers: [
        { provide: DateAdapter, useClass: WaiDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: WAI_DATE_FORMATS },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormDatePickerComponent extends FormInputComponent implements OnChanges, AfterViewInit {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public isDisabled = false;
  @Input() public minDate: Date = null;
  @Input() public maxDate: Date = null;
  @Output() public dateChange = new EventEmitter<MatDatepickerInputEvent<Date>>();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled'] && this.control) {
      this.updateDisabledState();
    }
  }

  public ngAfterViewInit(): void {
    this.updateDisabledState();
  }

  private updateDisabledState(): void {
    if (this.isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }

  public onDateChange(change: MatDatepickerInputEvent<Date>): void {
    this.dateChange.emit(change);
  }
}
